import { api } from '@/api/client'

export async function listAttachments(customerId, slug) {
  const { data } = await api.get(
    `/customers/${customerId}/categories/${slug}/attachments`,
  )
  return data
}

export async function uploadAttachment(customerId, slug, file) {
  const form = new FormData()
  form.append('file', file)
  const { data } = await api.post(
    `/customers/${customerId}/categories/${slug}/attachments`,
    form,
    {
      timeout: 120000,
      headers: { 'Content-Type': undefined },
    },
  )
  return data
}

export async function deleteAttachment(customerId, slug, attachmentId) {
  await api.delete(
    `/customers/${customerId}/categories/${slug}/attachments/${attachmentId}`,
  )
}

export async function downloadAttachment(
  customerId,
  slug,
  attachmentId,
  filename,
) {
  const { data } = await api.get(
    `/customers/${customerId}/categories/${slug}/attachments/${attachmentId}/download`,
    { responseType: 'blob', timeout: 120000 },
  )
  const url = URL.createObjectURL(data)
  const a = document.createElement('a')
  a.href = url
  a.download = filename || 'download'
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}

export async function getAttachmentUsage() {
  const { data } = await api.get('/settings/attachments/usage')
  return data
}
